// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"eecb62c5","703":"ab84ff8b","787":"fe2b37af"}[chunkId] + ".chunk.js";
};